import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ParticipantsModal } from "../Modals/ParticipantsModal";

export const SingleWorkshopRow = ({ props }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const [modal, setModal] = useState("");
  const {
    id,
    title,
    date,
    start_time,
    end_time,
    expert_name,
    description,
    price,
  } = props;
  return (
    <tr>
      <td>{id}</td>
      <td>{title}</td>
      <td>{date}</td>
      <td>{start_time}</td>
      <td>{end_time}</td>
      <td> {expert_name} </td>
      <td>{description}</td>
      <td> {price} </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn action-btn disabledButton"
            onClick={() => {
              setModal("Participants");
              onOpen();
            }}
          >
            View
          </button>
        </div>
      </td>
      {modal === "Participants" && (
        <ParticipantsModal isOpen={isOpen} onClose={onClose} id={id} />
      )}
    </tr>
  );
};
